shadow$provide[188] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Group:{enumerable:true, get:function() {
  return Group;
}}});
var require$_DOT__SLASH_parent_DOT_js = require("./parent.js");
class Group extends require$_DOT__SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "object", "entity", "visible", "active"];
  }
  make() {
    this._helpers.visible.make();
    return this._helpers.active.make();
  }
  unmake() {
    this._helpers.visible.unmake();
    return this._helpers.active.unmake();
  }
}
Group.initClass();

};